import { ApiMethod } from '../../types/types';
import { fetchApiMethod } from '../../api/utils/fetchApiMethod';
import { HandlerRequestContext } from '../../api/types/types';
import { ResponseActionHandler } from '../../types/context';

// For field handlers — remaps HTTP response keys → field names.
// Falls back to {} when the response is not a plain object so that
// merging into the host state is always safe.
export const executeHandler = async (
  apiMethod: ApiMethod,
  context: HandlerRequestContext,
  getResponseActionHandler?: (
    name: string
  ) => ResponseActionHandler | undefined,
  forceHeader?: string
): Promise<Record<string, unknown>> => {
  const result = await fetchApiMethod(
    apiMethod,
    context,
    getResponseActionHandler,
    forceHeader
  );

  // Anything that is not a plain object cannot map onto form fields.
  if (!result || typeof result !== 'object' || Array.isArray(result)) {
    return {};
  }

  return result as Record<string, unknown>;
};
